module.exports = __webpack_public_path__ + "img/reflect-lake.3443b98.jpg";